import 'tom-select/dist/css/tom-select.bootstrap5.css';
import TomSelect from 'tom-select';

document.querySelectorAll('[data-behavior="dropdown"]').forEach((item)=> {
  new TomSelect(item, {
    create: false,
    allowEmptyOption: false //item.dataset.blank || true
  })
})
